const schema = {
  'title': '送餐關懷',
  'type': 'object',
  'required': [],
  'properties': {
    'deliveryResult': {
      'type': 'string',
      'title': '下列狀態請四選一 *',
      'enum': ['atHome', 'leftThere', 'receivedByRelative', 'broughtBack'],
      'enumNames': ['個案在家', '個案未遇，餐點放置定點', '個案未遇，餐點親友代領', '個案未遇，餐點帶回'],
    },
    'checkListReminder': {
      'type': 'boolean',
      'title': '生活提醒(氣候、保暖、補充水份)',
      'enum': [true, false],
      'enumNames': ['是', '否'],
      'default': false,
    },
    'checkListChat': {
      'type': 'boolean',
      'title': '跟長輩聊天關心(身體、生活)',
      'enum': [true, false],
      'enumNames': ['是', '否'],
      'default': false,
    },
    'diary': {
      'type': ['string', 'null'],
      'title': '日誌',
    },
  },
};

export default schema;
